import { Link } from '@inertiajs/react';
import { Eye } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { supplierPath } from '@/routes';
import type { Supplier } from '@/types';

interface HasModel<T> { model: T }
const hasModel = <T,>(p: unknown): p is HasModel<T> =>
  typeof p === 'object' && p !== null && 'model' in (p as Record<string, unknown>);

// RevoGrid passes 'model' containing the complete row data object
export const SupplierActionsCell = (props: unknown) => {
  let supplier: Supplier;
  if (hasModel<Supplier>(props)) {
    supplier = props.model;
  } else {
    supplier = props as Supplier;
  }

  return (
    <div className="flex justify-center items-center h-full">
      <Button variant="ghost" size="sm" asChild>
        <Link href={supplierPath(supplier)}>
          <Eye className="h-4 w-4 mr-1" />
          Ver
        </Link>
      </Button>
    </div>
  );
};